import getLang from 'I18n/utils/getLang';
import styled from 'foundations-theming/utils';
import Raven from 'raven-js';
import { useEffect, useState } from 'react';
import { getFullPublicUrl, getPublicLocalizedPathname } from '../../utils/urls';
import { MARKETING_EMBED_NAV_CSS_ID, MARKETING_EMBED_NAV_CSS_QA_URL, MARKETING_EMBED_NAV_CSS_URL, MARKETING_EMBED_NAV_SCRIPT_ID, MARKETING_EMBED_NAV_SCRIPT_QA_URL, MARKETING_EMBED_NAV_SCRIPT_URL } from './MarketingNav.constants';
import { useLoadMarketingEmbedNavAsset, useMarketingEmbedNavLanguages, useMarketingNavQa } from './MarketingNav.hooks';
import { getMarketingEmbedNavLocale, getWindowLocation } from './MarketingNav.utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const LOAD_INTERVAL = 500;
const LOAD_TIMEOUT = 10000;
const MAX_WIDTH = 1280;
function createGlobalNavStyledDiv(maxWidthSelector) {
  return styled.div.withConfig({
    displayName: "EmbeddedGlobalNav",
    componentId: "sc-1kivzgv-0"
  })(() => ({
    [maxWidthSelector]: {
      maxWidth: `${MAX_WIDTH}px !important`
    }
  }));
}
const StyledGlobalNavHeader = createGlobalNavStyledDiv('.cl-page-width');
const StyledGlobalNavFooter = createGlobalNavStyledDiv('.hsg-footer__layout');
export function EmbeddedGlobalNav({
  _useMarketingNavCdnQa,
  children,
  location,
  loginUrl,
  navCtaText,
  navCtaUrl
}) {
  var _HSGlobalNav;
  const lang = getLang();
  const [ready, setReady] = useState(false);
  const marketingEmbedNavQa = useMarketingNavQa(_useMarketingNavCdnQa);
  const {
    loading: scriptLoading,
    error: scriptError
  } = useLoadMarketingEmbedNavAsset({
    assetId: MARKETING_EMBED_NAV_SCRIPT_ID,
    assetType: 'script',
    assetUrl: marketingEmbedNavQa ? MARKETING_EMBED_NAV_SCRIPT_QA_URL : MARKETING_EMBED_NAV_SCRIPT_URL,
    initialLoading: !((_HSGlobalNav = window.HSGlobalNav) !== null && _HSGlobalNav !== void 0 && _HSGlobalNav.load)
  });
  const {
    error: cssError
  } = useLoadMarketingEmbedNavAsset({
    assetId: MARKETING_EMBED_NAV_CSS_ID,
    assetType: 'css',
    assetUrl: marketingEmbedNavQa ? MARKETING_EMBED_NAV_CSS_QA_URL : MARKETING_EMBED_NAV_CSS_URL,
    initialLoading: !document.getElementById(MARKETING_EMBED_NAV_CSS_ID)
  });
  const languages = useMarketingEmbedNavLanguages({
    location: location || getWindowLocation()
  });
  useEffect(() => {
    if (scriptError) {
      console.error('[EmbeddedGlobalNav] Error loading script', scriptError);
    }
    if (cssError) {
      console.error('[EmbeddedGlobalNav] Error loading css', cssError);
    }
  }, [scriptError, cssError]);
  useEffect(() => {
    let timer = 0;
    const intervalId = setInterval(() => {
      var _HSGlobalNav2;
      if ((_HSGlobalNav2 = window.HSGlobalNav) !== null && _HSGlobalNav2 !== void 0 && _HSGlobalNav2.load && !scriptLoading) {
        setReady(true);
        clearInterval(intervalId);
        return;
      }
      if (timer > LOAD_TIMEOUT) {
        console.error('[EmbeddedGlobalNav] Timeout waiting for ready');
        setReady(true);
        clearInterval(intervalId);
        return;
      }
      timer += LOAD_INTERVAL;
    }, LOAD_INTERVAL);
    return () => {
      clearInterval(intervalId);
    };
  }, [scriptLoading]);
  useEffect(() => {
    var _HSGlobalNav3;
    if (ready && (_HSGlobalNav3 = window.HSGlobalNav) !== null && _HSGlobalNav3 !== void 0 && _HSGlobalNav3.load) {
      try {
        window.HSGlobalNavConfig = {
          languages,
          locale: getMarketingEmbedNavLocale(lang),
          loginUrl
        };
        window.HSGlobalNavCustomizations = {
          cta1: navCtaText && navCtaUrl ? {
            text: navCtaText,
            url: navCtaUrl
          } : undefined,
          isLoggedIn: false,
          logoDest: `${getFullPublicUrl()}${getPublicLocalizedPathname(lang)}`,
          searchDisabled: true
        };
        window.HSGlobalNav.load();
      } catch (error) {
        console.error('[EmbeddedGlobalNav] Error loading global nav', error);
        Raven.captureException(error);
      }
    }
  }, [lang, languages, loginUrl, navCtaText, navCtaUrl, ready]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(StyledGlobalNavHeader, {
      className: "hs-global-nav hs-global-nav-header hs-global-nav-loading"
    }), ready && children, /*#__PURE__*/_jsx(StyledGlobalNavFooter, {
      className: "hs-global-nav hs-global-nav-footer hs-global-nav-loading"
    })]
  });
}